import ApiService from '../apiservice'

export default class ParametrosPublicacoesService extends ApiService {
  constructor() {
    super('/parametros-publicacoes');
  }

  consultar(empresaId) {
    return this.get(`/${empresaId}`);
  }

  alterar(parametros) {
    return this.put('/',parametros);
  }

  cadastrarProcessos(processos,parametroId) {
    return this.post(`/cadastrar-processos/${parametroId}`,processos);
  }

	cadastrarUsuariosPublicacoesEmail(usuarios) {
		return this.post('/cadastrar-usuarios-emails-publicacoes',usuarios);
	}
}